import { getModalContext } from '@astlai/common/contexts/modal.context.svelte.ts';
import type { SecondarySourceOption } from '#src/types/secondary-sources.ts';
import { openAnchoredModal } from './menu';
import SecondarySourcesMenu from './SecondarySourcesMenu.svelte';

// Approximate rendered dimensions used for overflow detection.
// These must stay in sync with SecondarySourcesMenu.svelte styles.
const SOURCE_ROW_HEIGHT = 62; // padding (0.5rem * 2) + name (~1.2rem) + description (~1.2rem) + gap
const SOURCES_MENU_WIDTH = 340;

export function secondarySourcesMenu({ sources }: { sources: () => SecondarySourceOption[] }) {
	const modalCtx = getModalContext();

	return (node: HTMLElement) => {
		node.style.cursor = 'pointer';

		const clickHandler = () => {
			const items = sources();
			openAnchoredModal(
				modalCtx,
				node,
				SecondarySourcesMenu,
				{ sources: items },
				{
					estimatedHeight: items.length * SOURCE_ROW_HEIGHT,
					width: SOURCES_MENU_WIDTH,
					offset: { x: 0, y: 8 }
				}
			);
		};

		node.addEventListener('click', clickHandler);
		return () => node.removeEventListener('click', clickHandler);
	};
}
